"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CircleCheckmark = function CircleCheckmark(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M12.003 19.506a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm4.188-11.068a.625.625 0 00-.953.087l-4.014 5.747-1.836-2.629a.625.625 0 00-.952-.086.652.652 0 00-.054.834l2.07 2.964a.942.942 0 001.544 0l4.248-6.083a.652.652 0 00-.053-.834z"
  }));
};

var _default = (0, _react.forwardRef)(CircleCheckmark);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CircleCheckmark, "CircleCheckmark", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CircleCheckmark.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CircleCheckmark.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9DaXJjbGVDaGVja21hcmsudHN4Il0sIm5hbWVzIjpbIkNpcmNsZUNoZWNrbWFyayIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxlQUErRSxHQUFHLFNBQWxGQSxlQUFrRixDQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxTQUN0RjtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RELEtBQXBEO0FBQTJELElBQUEsR0FBRyxFQUFFQztBQUFoRSxNQUNFO0FBQ0UsSUFBQSxJQUFJLEVBQUMsY0FEUDtBQUVFLElBQUEsQ0FBQyxFQUFDO0FBRkosSUFERixDQURzRjtBQUFBLENBQXhGOztlQVNlLHVCQUFXRixlQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLGUiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IENpcmNsZUNoZWNrbWFyazogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTIuMDAzIDE5LjUwNmE3LjUgNy41IDAgMTEwLTE1IDcuNSA3LjUgMCAwMTAgMTV6bTQuMTg4LTExLjA2OGEuNjI1LjYyNSAwIDAwLS45NTMuMDg3bC00LjAxNCA1Ljc0Ny0xLjgzNi0yLjYyOWEuNjI1LjYyNSAwIDAwLS45NTItLjA4Ni42NTIuNjUyIDAgMDAtLjA1NC44MzRsMi4wNyAyLjk2NGEuOTQyLjk0MiAwIDAwMS41NDQgMGw0LjI0OC02LjA4M2EuNjUyLjY1MiAwIDAwLS4wNTMtLjgzNHpcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihDaXJjbGVDaGVja21hcmspO1xuIl19